import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { vc_base, vc_color } from '../assets/js/Brand'

// components
import Heading from '../components/atoms/BaseHeading'
import Txt from '../components/atoms/BaseTxt'
import Breadcrumb from '../components/molecules/Breadcrumb'
import Pagination from '../components/molecules/Pagination'
import ListItem from '../components/molecules/ListItem'
import Layout from '../components/templates/Default'

// template
const categoryTwo = (props) => {
  // 現在の中カテゴリーの情報取得
  const thisCat = props.data.markdownRemark
  // 現在のページの記事情報取得
  const posts = props.data.currentPost.edges
  // 現在の中カテゴリーの親カテゴリー情報取得
  const parentCat = props.data.currentParent.edges
  // 現在の中カテゴリーの記事数取得
  const totalCount = props.data.currentAllPost.totalCount

  // ページネーション用
  const { catOne, catTwo, currentPage, numPages } = props.pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const hasPages = numPages <= 2 ? true : false
  const prevPage =
    currentPage - 1 === 1
      ? `/${catOne}/${catTwo}/`
      : `/${catOne}/${catTwo}/${currentPage - 1}`.toString()
  const nextPage = `/${catOne}/${catTwo}/${currentPage + 1}`.toString()

  return (
    <Layout
      catOne={parentCat[0].node.frontmatter.cat}
      catTwo={thisCat.frontmatter.cat}
    >
      <Helmet>
        <html lang="ja" />
        <meta charSet="utf-8" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Cache-Control" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
        <title>
          {`${thisCat.frontmatter.title}${
            !isFirst ? ` ${currentPage}ページ目` : ''
          }｜${parentCat[0].node.frontmatter.title}`}
          ｜ヘルプ
        </title>
      </Helmet>

      <Breadcrumb
        breadcrumb={[
          {
            id: 1,
            name: parentCat[0].node.frontmatter.title,
            link: parentCat[0].node.fields.slug,
          },
        ]}
      />

      <Heading level={1} className="title-page">
        {thisCat.frontmatter.title}
        <TotalCount>（全{totalCount}件）</TotalCount>
      </Heading>

      <PageList>
        <ul>
          {posts.map(({ node }) => {
            return (
              <ListItem key={node.id} link={node.fields.slug}>
                <Txt type={'span'} className="anchor-text">
                  {node.frontmatter.title}
                </Txt>
              </ListItem>
            )
          })}
        </ul>
      </PageList>

      <Pagination
        link={`/${catOne}/${catTwo}/`}
        currentPage={currentPage}
        numPages={numPages}
        isFirst={isFirst}
        isLast={isLast}
        hasPages={hasPages}
        prevPage={prevPage}
        nextPage={nextPage}
      />
    </Layout>
  )
}

export default categoryTwo

// script
export const pageQuery = graphql`
  query($skip: Int, $limit: Int, $target: String, $catOne: String) {
    markdownRemark(fields: { slug: { eq: $target } }) {
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }
    currentPost: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { kind: { eq: "faq" }, posttype: { eq: "post" } }
        fields: { slug: { regex: $target } }
      }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            kind
            posttype
            cat
            order
            title
            date
          }
        }
      }
    }

    currentParent: allMarkdownRemark(
      filter: {
        frontmatter: { cat: { eq: $catOne }, posttype: { eq: "catOne" } }
      }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            kind
            posttype
            cat

            order
            title
            date
          }
        }
      }
    }

    currentAllPost: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { kind: { eq: "faq" }, posttype: { eq: "post" } }
        fields: { slug: { regex: $target } }
      }
    ) {
      totalCount
    }
  }
`

// style
const TotalCount = styled.span`
  font-size: 65%;
  font-weight: normal;
`
const PageList = styled.div`
  border: 1px solid ${vc_color.border};
  border-radius: ${vc_base.pixel`0.5`};
  margin-top: ${vc_base.pixel};
`
